module.exports = __webpack_public_path__ + "img/giraffe-body.326addfc.jpg";